module.exports = __webpack_public_path__ + "img/maincube_5.e4de6941.jpg";